module.exports = __webpack_public_path__ + "media/images/webpage/shared/checklist/none-406e6d5e66122264a8aaac92b9658a27.svg";